import React from 'react';

import Stack from '@mui/system/Stack';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import CreditCardIcon from '@mui/icons-material/CreditCard';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import PaymentsIcon from '@mui/icons-material/Payments';

import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import StripeHero from 'assets/images/addFI/StripeHero.svg';
import StripeHeroDark from 'assets/images/addFI/StripeHeroDark.svg';
import StripeLogo from 'assets/logos/stripe.svg';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';

type Props = {
  onContinue: () => void;
};

const PaymentProvider = (props: Props) => {
  const { onContinue } = props;
  const theme = useTheme();

  return (
    <>
      <StdDialogContent
        id='payment_provider_dialog'
        sx={{ display: 'flex', flexDirection: 'column', mt: 0, mx: 0, p: 0 }}
      >
        <img alt='stripe-hero' src={theme.mode === 'dark' ? StripeHeroDark : StripeHero} />
        <Stack direction='row' justifyContent='space-between' mt={3} mx={3}>
          <List sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '372px', p: 0 }}>
            <ListItem sx={{ p: 0 }}>
              <ListItemIcon sx={{ alignSelf: 'flex-start' }}>
                <CreditCardIcon color='primary' fontSize='large' />
              </ListItemIcon>
              <ListItemText
                primary='Accept more payment methods'
                primaryTypographyProps={{ variant: 'paragraphBold' }}
                secondary='Streamline client payments with choices they know and trust.'
                secondaryTypographyProps={{ variant: 'paragraphRegular' }}
                sx={{ mt: 0 }}
              />
            </ListItem>
            <ListItem sx={{ p: 0 }}>
              <ListItemIcon sx={{ alignSelf: 'flex-start' }}>
                <ElectricBoltIcon color='primary' fontSize='large' />
              </ListItemIcon>
              <ListItemText
                primary='Get your money sooner'
                primaryTypographyProps={{ variant: 'paragraphBold' }}
                secondary='Go from sent to paid in record time with the conveniece of online payments.'
                secondaryTypographyProps={{ variant: 'paragraphRegular' }}
                sx={{ mt: 0 }}
              />
            </ListItem>
            <ListItem sx={{ p: 0 }}>
              <ListItemIcon sx={{ alignSelf: 'flex-start' }}>
                <PaymentsIcon color='primary' fontSize='large' />
              </ListItemIcon>
              <ListItemText
                primary='Save time tracking invoice payments'
                primaryTypographyProps={{ variant: 'paragraphBold' }}
                secondary='Automatically mark invoices as paid to quickly see which ones are outstanding.'
                secondaryTypographyProps={{ variant: 'paragraphRegular' }}
                sx={{ mt: 0 }}
              />
            </ListItem>
          </List>
          <Stack
            direction='column'
            gap={2}
            px={3}
            width='290px'
            sx={{ borderRadius: '12px', background: theme.palette.info.light }}
          >
            <img alt='stripe-logo' src={StripeLogo} width='122px' height='58px' style={{ alignSelf: 'center' }} />
            <Stack>
              <Typography variant='paragraphBold'>No upfront or monthly fees</Typography>
            </Stack>
            <Stack>
              <Typography variant='paragraphMedium'>Card payments</Typography>
              <Typography variant='paragraphRegular'>2.9% + $0.30 per transaction</Typography>
            </Stack>
            <Stack>
              <Typography variant='paragraphMedium'>Bank payments</Typography>
              <Typography variant='paragraphRegular'>0.8% ($5 max) per transaction</Typography>
            </Stack>
          </Stack>
        </Stack>
      </StdDialogContent>
      <StdDialogActions
        // sx={{ display: 'flex', flexGrow: 0 }}
        primary={{
          children: 'Continue',
          id: 'continueButton',
          onClick: onContinue,
        }}
      />
    </>
  );
};

export default PaymentProvider;
